import React from 'react';
import Card from '~/src/components/Card';
import MiniSpinner from '~/src/components/Spinner/MiniSpinner';
import { InlineNotification } from '~/src/components/Notification/InlineNotification';
import { usePaymentMethodIframeUrl } from '~/src/hooks/cbs/usePaymentMethodIframeUrl';
import { UpdatePaymentMethodButton } from '~/src/pages/Settings/subpages/SettingsSubscription/UpdatePaymentMethodButton';

interface PaymentInfoCardProps {
  subscription?: any;
}

export const PaymentInfoCard: React.FC<PaymentInfoCardProps> = ({
  subscription,
}) => {
  const { data: paymentMethodIframe, isLoading } = usePaymentMethodIframeUrl();
  const lastPaymentStatus = subscription?.last_payment_status;
  const iframeUrl = paymentMethodIframe?.payment_method_iframe_url;

  return (
    <Card>
      <div className="flex items-center justify-between">
        <div className="text-lg font-bold">Payment info</div>
        <UpdatePaymentMethodButton />
      </div>

      <div className="mt-3">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <MiniSpinner className="text-gray-400" />
          </div>
        ) : iframeUrl ? (
          <iframe
            src={iframeUrl}
            title="Payment method"
            className="w-full border-none rounded"
            style={{ minHeight: '120px' }}
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
          />
        ) : (
          <div className="text-sm text-gray-500 py-4 text-center">
            Unable to load payment method details.
          </div>
        )}
      </div>

      {lastPaymentStatus === 'payment_action_required' && (
        <div className="mt-2">
          <InlineNotification
            type="error"
            title="Payment Action Required"
            message="Your payment method requires attention. Please update it to continue service."
          />
        </div>
      )}
    </Card>
  );
};
